export default "__VITE_ASSET__Ce1Ul48x__"